import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Button, Container } from '@material-ui/core';
import T from 'i18n-react';
import FreePlanComponent from './components/FreePlanComponent';
import ErpPlanComponent from './components/ErpPlanComponent';
import CompliancePlanComponent from './components/CompliancePlanComponent';

const useStyles = makeStyles((theme) => ({
  container: {
    height: '100%',
  },

  '@media screen and (min-width: 767px)': {
    divider: {
      borderRight: '1px solid #C4C8D0 !important',
    },
    paper: {
      padding: '20px 40px',
      textAlign: 'left',
    },
    checkbox: {
      top: '30%',
    },
  },
  '@media screen and (max-width: 767px)': {
    divider: {
      borderBottom: '1px solid #C4C8D0 !important',
    },
    paper: {
      padding: '20px',
      textAlign: 'center',
    },
    title: {
      textAlign: 'center',
    },
  },
  button: {
    padding: '10px 20px',
    background: '#005EFF',
    borderRadius: '2px',
    color: '#FFFFFF',
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '16px',
    textAlign: 'center',
    '&:hover': {
      background: '#005EFF',
    },
  },
  backBtn: {
    fontSize: '14px',
    fontWeight: '500',
    color: '#005EFF',
  },
}));

const SubscriptionPlan = ({ stepper, setStepper, selectedPlan, setSelectedPlan, handleSubmit }) => {
  const classes = useStyles();

  const handleChange = (event) => {
    setSelectedPlan(event.target.name);
  };

  const RenderButton = () => (
    <>
      <Box display='flex' justifyContent='center' py={2}>
        <Button classes={{ root: classes.button }} onClick={handleSubmit}>
          {T.translate('iSource.buyerForm.submitBtn')}
        </Button>
      </Box>
      <Box display='flex' justifyContent='center'>
        <Button
          classes={{ root: classes.backBtn }}
          varaint='text'
          onClick={() => setStepper({ selectPlan: false, submitForm: true, selectedPlan: false })}>
          {T.translate('iSource.buyerForm.back')}
        </Button>
      </Box>
    </>
  );

  const RenderSelectionTitle = () => (
    <Box display='block' py={2}>
      <Box
        py={1}
        fontSize='28px'
        fontWeight='bold'
        color='#232B3A'
        justifyContent='center'
        alignItems='center'
        lineHeight='normal'
        textAlign='center'>
        {T.translate('iSource.buyerForm.selectionPlan.title')}
      </Box>
      <Box
        fontSize='20px'
        fontWeight='normal'
        color='#8991A0'
        justifyContent='center'
        alignItems='center'
        lineHeight='normal'
        textAlign='center'>
        {T.translate('iSource.buyerForm.selectionPlan.subtitle')}
      </Box>
    </Box>
  );

  const RenderSelectionSubTitle = () => (
    <Box fontSize='22px' fontWeight='bold' lineHeight='34px' py={2}>
      <div className={classes.title}>{T.translate('iSource.buyerForm.selectionPlan.subTopic')}</div>
    </Box>
  );

  return (
    <div className={classes.root}>
      <Box bgcolor='#F4F6FA' height='100vh'>
        <Container classes={{ maxWidthMd: classes.container }} component='div' maxWidth='md'>
          <RenderSelectionTitle />
          <FreePlanComponent handleChange={handleChange} selectedPlan={selectedPlan} />
          <RenderSelectionSubTitle />
          <ErpPlanComponent handleChange={handleChange} selectedPlan={selectedPlan} />
          <CompliancePlanComponent handleChange={handleChange} selectedPlan={selectedPlan} />
          <RenderButton />
        </Container>
      </Box>
    </div>
  );
};

SubscriptionPlan.propTypes = {
  //
};

export default SubscriptionPlan;
